import { useMutation, useQuery } from 'react-query'
import { initPaymentWallet } from 'services/wallet'

export default function useGetInitBoxPaymentOs(id: undefined | number) {
    const { data, isLoading } = useQuery(
        ['init-payment-os-wallet', id],
        initPaymentWallet
    )
    return { data, isLoading }
}